"use client";

import { useAtomValue } from "jotai";
import { demoToastState } from "@/features/demo/model/demoToast.atom";

const ToastContainer = () => {
  const toasts = useAtomValue(demoToastState);

  return (
    <div className="absolute left-1/2 top-[-60px] z-50 flex translate-x-[-50%] flex-col gap-2">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className="animate-fade-in-up flex h-[52px] items-center justify-center rounded-[4px] bg-black/80 px-[30px] text-white"
        >
          {toast.message}
        </div>
      ))}
    </div>
  );
};

export default ToastContainer;
